import type { DrawdownMatrixCellStatus } from '@/types/drawdown';

const CELL_CLASSES: Record<DrawdownMatrixCellStatus, string> = {
  paid: 'bg-green-50 text-green-700 dark:bg-green-950/40 dark:text-green-400',
  partial:
    'bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-400',
  overdue:
    'bg-red-50 text-red-700 font-semibold dark:bg-red-950/40 dark:text-red-400',
  pending: 'bg-muted/40 text-muted-foreground',
  exempted: 'text-muted-foreground',
  draft: 'text-muted-foreground italic',
};

const LEGEND_SWATCH_CLASSES: Record<DrawdownMatrixCellStatus, string> = {
  paid: 'bg-green-600',
  partial: 'bg-amber-500',
  overdue: 'bg-red-600',
  pending: 'bg-muted-foreground/30',
  exempted: 'bg-transparent border border-border',
  draft: 'bg-transparent border border-dashed border-muted-foreground',
};

const STATUS_LABELS: Record<DrawdownMatrixCellStatus, string> = {
  paid: 'Paid',
  partial: 'Partial',
  overdue: 'Overdue',
  pending: 'Not yet due',
  exempted: 'Exempt',
  draft: 'Draft',
};

export const LEGEND_STATUSES: DrawdownMatrixCellStatus[] = [
  'paid',
  'partial',
  'overdue',
  'pending',
  'exempted',
  'draft',
];

export const getCellClass = (status: DrawdownMatrixCellStatus): string =>
  CELL_CLASSES[status];

export const getLegendSwatchClass = (
  status: DrawdownMatrixCellStatus
): string => LEGEND_SWATCH_CLASSES[status];

export const getStatusLabel = (status: DrawdownMatrixCellStatus): string =>
  STATUS_LABELS[status];
